import styled from 'styled-components';
import colors from '../../../config/colors.json';

export const StyledCard = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: end;
    border-radius: 8px;
    padding: 33px;
    background-color: ${colors.light};
    box-shadow: 0 2px 2px #9C9C9C24;
    flex: 1;

    .text-title {
        margin-bottom: 6px;
    }

    h4 {
        font-family: Poppins, Heltica, Arial, sans-serif;
        font-weight: medium;
        font-size: 17px;
        letter-spacing: 0;
        color: ${colors.darkGrey};        
        vertical-align: middle;
        margin-bottom: 0;
        display: inline-block;
        line-height: 34px;
      }
    
    .content-body {
        font-family: Poppins, Heltica, Arial, sans-serif;
        color: ${colors.darkGrey};
        font-size: 30px;
        text-align: center;
        line-height: 60px;
    }

    @media screen and (max-width: 1919px) {
        padding: 15px;
        .text-title {
            margin-bottom: 0;
        }
        h4 {
            line-height: 30px;
            font-size: 15px;
        }
        .content-body {
            line-height: 30px;
            font-size: 26px;
        }
}
`;
